import React from 'react';

import LoaderContainer from './styled/LoaderContainer';
import { DOTS_COUNT } from './constants';
import { LoaderProps } from './types';

const Loader: React.FC<LoaderProps> = props => (
  <LoaderContainer {...props}>
    {Array.from(Array(DOTS_COUNT), (v, i) => (
      <div key={i} />
    ))}
  </LoaderContainer>
);

export default Loader;
